export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12903.d71c27d0.jpg";